/**
 * @generated SignedSource<<cf06b39e088cbe6a0d46046d572a85d2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type MarkTxnsInternalInputObject = {
  destinationBankAccountId?: string | null | undefined;
  destinationName?: string | null | undefined;
  txnIds: ReadonlyArray<string>;
};
export type cashPositionTxnsPanel_MarkTxnsInternalMutation$variables = {
  input: MarkTxnsInternalInputObject;
};
export type cashPositionTxnsPanel_MarkTxnsInternalMutation$data = {
  readonly markTxnsInternal: {
    readonly errors: ReadonlyArray<{
      readonly message: string;
    }>;
    readonly updatedCount: number;
  } | null | undefined;
};
export type cashPositionTxnsPanel_MarkTxnsInternalMutation = {
  response: cashPositionTxnsPanel_MarkTxnsInternalMutation$data;
  variables: cashPositionTxnsPanel_MarkTxnsInternalMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedCount",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "cashPositionTxnsPanel_MarkTxnsInternalMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "MarkTxnsInternalMutationPayload",
        "kind": "LinkedField",
        "name": "markTxnsInternal",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "cashPositionTxnsPanel_MarkTxnsInternalMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "MarkTxnsInternalMutationPayload",
        "kind": "LinkedField",
        "name": "markTxnsInternal",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "001b3e9054cf3b40e6ce691e3bca2088",
    "id": null,
    "metadata": {},
    "name": "cashPositionTxnsPanel_MarkTxnsInternalMutation",
    "operationKind": "mutation",
    "text": "mutation cashPositionTxnsPanel_MarkTxnsInternalMutation(\n  $input: MarkTxnsInternalInputObject!\n) {\n  markTxnsInternal(input: $input) {\n    updatedCount\n    errors {\n      message\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "cfd5eff9dac695aad6f7ee69d442a848";

export default node;
